// extracted by mini-css-extract-plugin
module.exports = {"agentPage":"admin-agent-details_agentPage_3HZa9","agentInfo":"admin-agent-details_agentInfo_ikyjK","agentInfoItem":"admin-agent-details_agentInfoItem_1G8XC"};